import { cn } from '@/utils';
import { Slot } from '@radix-ui/react-slot';
import { ChevronRight, MoreHorizontal } from 'lucide-react';
import * as React from 'react';

const Breadcrumb = React.forwardRef(({ ...props }, ref) => <nav aria-label="breadcrumb" ref={ref} {...props}/>);
Breadcrumb.displayName = 'Breadcrumb';

const BreadcrumbList = React.forwardRef(({ className, ...props }, ref) => (
    <ol
        className={cn(
            'tw-flex tw-flex-wrap tw-items-center tw-gap-1.5 tw-break-words tw-text-sm tw-text-muted-foreground sm:tw-gap-2.5',
            className
        )}
        ref={ref}
        {...props}/>
));
BreadcrumbList.displayName = 'BreadcrumbList';

const BreadcrumbItem = React.forwardRef(({ className, ...props }, ref) => (
    <li
        className={cn('tw-inline-flex tw-items-center tw-gap-1.5', className)}
        ref={ref}
        {...props}/>
));
BreadcrumbItem.displayName = 'BreadcrumbItem';

const BreadcrumbLink = React.forwardRef(({ asChild, className, ...props }, ref) => {
    const Comp = asChild ? Slot : 'a';

    return (
        (<Comp
            className={cn('tw-transition-colors hover:tw-text-foreground', className)}
            ref={ref}
            {...props}/>)
    );
});
BreadcrumbLink.displayName = 'BreadcrumbLink';

const BreadcrumbPage = React.forwardRef(({ className, ...props }, ref) => (
    <span
        aria-current="page"
        aria-disabled="true"
        className={cn('tw-font-normal tw-text-foreground', className)}
        ref={ref}
        role="link"
        {...props}/>
));
BreadcrumbPage.displayName = 'BreadcrumbPage';

const BreadcrumbSeparator = ({
    children,
    className,
    ...props
}) => (
    <li
        aria-hidden="true"
        className={cn('[&>svg]:tw-w-3.5 [&>svg]:tw-h-3.5', className)}
        role="presentation"
        {...props}>
        {children ?? <ChevronRight/>}
    </li>
);
BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';

const BreadcrumbEllipsis = ({
    className,
    ...props
}) => (
    <span
        aria-hidden="true"
        className={cn('tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center', className)}
        role="presentation"
        {...props}>
        <MoreHorizontal className="tw-h-4 tw-w-4"/>
        <span className="tw-sr-only">More</span>
    </span>
);
BreadcrumbEllipsis.displayName = 'BreadcrumbElipssis';

export {
    Breadcrumb,
    BreadcrumbList,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbPage,
    BreadcrumbSeparator,
    BreadcrumbEllipsis
};
